"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationsAPI = void 0;
const base_1 = require("../base");
class CertificationsAPI extends base_1.BaseAPI {
    /**
     * Get an up to date list of the officially supported movie certifications on TMDB.
     *
     * @see https://developers.themoviedb.org/3/certifications/get-movie-certifications
     */
    async movie() {
        const path = this.getPath('/certification/movie/list');
        return this.get(path);
    }
    /**
     * Get an up to date list of the officially supported TV show certifications on TMDB.
     *
     * @see https://developers.themoviedb.org/3/certifications/get-tv-certifications
     */
    async tv() {
        const path = this.getPath('/certification/tv/list');
        return this.get(path);
    }
}
exports.CertificationsAPI = CertificationsAPI;
